module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10040.0ce0036e.jpg";